module.exports = __webpack_public_path__ + "static/faktum-regular-c20e57a6760fabdaceb584820add4455.woff";